import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
const PrimaryPriceComponentWrapper = ({ children, marginTop, }) => {
    const boxStyleProps = {
        borderRadius: "radius.16",
        borderColor: "color.border.light.default",
        borderStyle: "solid",
        borderWidth: "borderWidth.1",
        paddingTop: "spacing.24",
    };
    return (_jsx(Box, Object.assign({}, boxStyleProps, { paddingBottom: "spacing.8", marginTop: marginTop, children: children })));
};
const SecondaryPriceComponentWrapper = ({ children, marginTop, }) => {
    const borderProps = {
        borderRadius: "radius.16",
    };
    return (_jsx(Box, Object.assign({}, borderProps, { backgroundColor: "color.background.light", paddingVertical: "spacing.24", marginTop: marginTop, children: children })));
};
const TertiaryPriceComponentWrapper = ({ children, marginTop, }) => {
    const styleProps = {
        borderRadius: "radius.16",
        marginLeft: "-spacing.16",
    };
    return (_jsx(Box, Object.assign({}, styleProps, { marginTop: marginTop, children: children })));
};
export const ComponentWrapper = ({ type, children, marginTop, isLast = false, }) => {
    if (type === "TERTIARY") {
        return (_jsx(TertiaryPriceComponentWrapper, { marginTop: marginTop, children: children }));
    }
    if (type === "SECONDARY") {
        return (_jsx(SecondaryPriceComponentWrapper, { marginTop: marginTop, isLast: isLast, children: children }));
    }
    return (_jsx(PrimaryPriceComponentWrapper, { marginTop: marginTop, children: children }));
};
